export const getFromLocalStorage = (key) => {
  const item = localStorage.getItem(key);

  if (!item) {
    return null;
  }

  try {
    return JSON.parse(item);
  } catch (e) {
    if (typeof item === 'string' || item instanceof String) return item;

    throw new Error(`Cannot parse local storage item from key "${key}". Item: "${item}".`);
  }
};

export const saveToLocalStorage = (key, item) => {
  try {
    const itemStringified = JSON.stringify(item);
    localStorage.setItem(key, itemStringified);
  } catch (e) {
    throw new Error(
      `Cannot parse and save item item to local storage with key: "${key}" and value: "${item}".`,
    );
  }
};

export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};
